import { array, Describe, is, number, type } from 'superstruct';

import { IconDto, IconValidator } from './Icon';

type IconListDto = {
  items: IconDto[];
  numFound: number;
  rows: number;
  start: number;
};

export const IconListValidator: Describe<IconListDto> = type({
  items: array(IconValidator),
  numFound: number(),
  rows: number(),
  start: number(),
});

export const isIconList = (obj: unknown) => is(obj, IconListValidator);
